module.exports = __webpack_public_path__ + "media/images/sales/nanairoweek/price-opening-261ecc4788fdca481d03d2c7f9508464.svg";